import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toolbar, IconButton } from '@mui/material/';
import { Menu as MenuIcon } from '@mui/icons-material/';
import { AppBar, ButtonsWrapper, LogoContainer } from './style';
import { useTypedTheme } from '@monorepo-web/styles';
export default function AppBarTop({ drawerwidth = 250, isDrawerLeftOpen = false, setIsDrawerLeftOpen, BotaoUser, Logo }) {
    const theme = useTypedTheme();
    const handleDrawerOpen = () => {
        if (typeof setIsDrawerLeftOpen == 'function') {
            setIsDrawerLeftOpen(true);
        }
    };
    return (_jsxs(AppBar, Object.assign({ position: "fixed", open: isDrawerLeftOpen, drawerwidth: drawerwidth, style: { background: theme.backgroundColorMain, boxShadow: theme.topMenuBoxShadow } }, { children: [_jsxs(Toolbar, { children: [setIsDrawerLeftOpen ?
                        _jsx(IconButton, Object.assign({ color: "inherit", "aria-label": "open drawer", onClick: handleDrawerOpen, edge: "start", sx: Object.assign({ mr: 2 }, (isDrawerLeftOpen && { display: 'none' })) }, { children: _jsx(MenuIcon, { style: { color: theme.fontColorMenu } }) }))
                        : null, BotaoUser ?
                        _jsx(ButtonsWrapper, { children: BotaoUser }) : null] }), Logo ?
                (_jsx(LogoContainer, { children: _jsx(Logo, {}) }))
                : null] })));
}
